import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isNull, isEqual, isArray } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import D3Graphviz from "../components/D3Graphviz";


import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewDataDictionary from "../components/ViewDataDictionary";
import ViewStructure from "../components/ViewStructure";
import Buffering from "../components/Buffering";


import { getDataDictionaryVersion, getDataDictionaryVersionStructures, zipDataDictionary } from "../utils/utilsDataDictionary";


class ViewDataDictionaryVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.handleControls = this.handleControls.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

        let StateChange = {};

        if (!isEqual(this.state, prevState)){

            if (this.state.loadData){
                this.loadData(this.state.idDataDictionary, this.state.idVersion);
                StateChange.loadData = false;
            }

            if (this.state.isLoaded && this.state.DataDictionary && this.state.idDataDictionary && this.state.idVersion){
                // Fetch formats from server
                if (this.state.DataDictionary !== prevState.DataDictionary){
                    const onLoadCsv = (csv) => {
                        this.setState({csv: csv});
                    };

                    const onFailCsv = (e) => {
                        console.error('Error fetching CSV:', e);
                    };

                    getDataDictionaryVersion(
                        this.dsd,
                        this.state.idDataDictionary,
                        this.state.idVersion,
                        onLoadCsv,
                        onFailCsv,
                        'csv'
                    );

                    const onLoadRdfs = (rdfs) => {
                        this.setState({rdfs: rdfs});
                    };

                    const onFailRdfs = (e) => {
                        console.error('Error fetching RDFS:', e);
                    };

                    getDataDictionaryVersion(
                        this.dsd,
                        this.state.idDataDictionary,
                        this.state.idVersion,
                        onLoadRdfs,
                        onFailRdfs,
                        'rdfs'
                    );

                    const onLoadSkos = (skos) => {
                        this.setState({skos: skos});
                    };

                    const onFailSkos = (e) => {
                        console.error('Error fetching SKOS:', e);
                    };

                    getDataDictionaryVersion(
                        this.dsd,
                        this.state.idDataDictionary,
                        this.state.idVersion,
                        onLoadSkos,
                        onFailSkos,
                        'skos'
                    );

                    const onLoadXsd = (xsds) => {
                        this.setState({xsds: xsds});
                    };

                    const onFailXsd = (e) => {
                        console.error('Error fetching XSD:', e);
                    };

                    getDataDictionaryVersion(
                        this.dsd,
                        this.state.idDataDictionary,
                        this.state.idVersion,
                        onLoadXsd,
                        onFailXsd,
                        'xsd'
                    );


                    const onLoadStructuresDot = (dots) => {
                        this.setState({dotStructures: dots});
                    };

                    const onFailStructuresDot = (e) => {
                        console.error('Error fetching DOT:', e);
                    };

                    getDataDictionaryVersionStructures(
                        this.dsd,
                        this.state.idDataDictionary,
                        this.state.idVersion,
                        onLoadStructuresDot,
                        onFailStructuresDot,
                        'dot',
                        null,
                        {vizStructures: true}
                    );


                }
            }

            this.setState(StateChange);
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idDataDictionary: null,
            type: null,
            DataDictionary: null,
            isLoaded: false,
            isFailed: false, 
            loadData: false,

            Controls: {
            },

            csv: null,
            rdfs: null,
            skos: null,
            xsds: null,
            dotStructures: null
        }

        StateChange.idVersion = getParam('idVersion', this.props);
        if (StateChange.idVersion){
            StateChange.loadData = true;
        }

        StateChange.idDataDictionary = getParam('idDataDictionary', this.props);
        if (StateChange.idDataDictionary){
            StateChange.loadData = true;
        }

        StateChange.isExporting = false;
        this.setState(StateChange);

    }

    loadData(id, idVersion){

        const onLoad = function(data){
            let StateChange = {};
            StateChange.DataDictionary = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);
            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.DataDictionary = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);


        if (id){
            getDataDictionaryVersion(this.dsd, id, idVersion, onLoad, onFail);
        }

        return;
    }

    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let DataDictionary = cloneObject(this.state.DataDictionary); 
            let Version = DataDictionary.Version;
            let idDataDictionary = this.state.idDataDictionary;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipDataDictionary(this.dsd, DataDictionary);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `datadictionary_${idDataDictionary}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }


    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Data Dictionary: ${this.state.DataDictionary.name}`}</PD.Heading>
                    {this.state.DataDictionary.Version &&
                        <>
                           {this.viewVersion(this.state.DataDictionary.Version)}
                        </>
                    }
                    {this.viewDataDictionary(this.state.DataDictionary)}
                </div>
            )
        }
        return null;

    };    

    viewVersion(Version){

        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                

                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }

                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
                
            )
        };
        return null;
    };

    viewDataDictionary(DataDictionary){
        if (DataDictionary){

            let countStructures = 0;
            if (DataDictionary.Structures){
                if (DataDictionary.Structures.length){
                    countStructures = DataDictionary.Structures.length;
                }
            }

            let vizoptions = {}
            vizoptions.engine = 'dot';
            vizoptions.fit = false;
            vizoptions.width = null;
            vizoptions.height = null;
            vizoptions.zoom = false;
            vizoptions.scale = 1;

            let styleDiv = {}

            return(
                <div>
                    <ViewDataDictionary DataDictionary={DataDictionary} noLinks/>

                    <PD.Heading level="2">Index</PD.Heading>
                    {countStructures &&
                        <fieldset>
                            <legend>Structures</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        DataDictionary.Structures.map(
                                            (Structure, pos) => 
                                            {                
                                                switch (Structure.status){
                                                    case 'deprecated': return null;
                                                    default:

                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#structure_${Structure._id}`} onClick={this.handleNavClick}>{Structure.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Structure.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    <fieldset>
                        <legend>Renditions</legend>
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>
                            <PD.Tbody>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_rdfs`} onClick={this.handleNavClick}>RDF Schema</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_skos`} onClick={this.handleNavClick}>SKOS</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_csv`} onClick={this.handleNavClick}>CSV</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_xsd`} onClick={this.handleNavClick}>XSD Schema</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                            </PD.Tbody>
                        </PD.Table>
                    </fieldset>


                    {
                        countStructures &&
                            <div>
                                <PD.Heading level="2">Structures</PD.Heading>
                                {
                                    DataDictionary.Structures.map(
                                        (Structure, pos) =>    
                                        {
                                            
                                            switch (Structure.status){
                                                case 'deprecated': return null;
                                                default:

                                                    return (
                                                        <fieldset key={pos} id={`structure_${Structure._id}`}>
                                                            <ViewStructure Structure={Structure} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <div name="divVizStructure" style={styleDiv} onClick={this.handleNavClick}>
                                                                    <D3Graphviz dot={this.state.dotStructures && this.state.dotStructures[Structure._id]} onClick={this.handleNavClick}/>
                                                                </div>
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }

                    <PD.Heading level="2">Renditions</PD.Heading>
                    {this.viewRDFS(DataDictionary._id)}
                    {this.viewSKOS(this.state.skos)}
                    {this.viewCSV(this.state.csv)}
                    {this.viewXSDs(this.state.xsds)}

                </div>
            )
        }
    }

    viewRDFS(idDataDictionary){

        return(
            <fieldset id={`rendition_rdfs`}>
                <legend>rdf schema</legend>
                <ViewDataDictionaryRdfs dsd={this.dsd} idDataDictionary={idDataDictionary} idVersion={this.state.idVersion}/>
            </fieldset>
        )
    }

    viewSKOS(skos){

        return(
            <fieldset id={`rendition_skos`}>
                <legend>SKOS</legend>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {skos}
                </pre>
            </fieldset>
        )
    }

    viewCSV(csv){

        return(
            <fieldset id={`rendition_csv`}>
                <legend>CSV</legend>
                <pre>
                    {csv}   
                </pre>
            </fieldset>
        )
    }

    viewXSDs(xsds = {}){

        return(
            <fieldset id={`rendition_xsd`}>
                <legend>XML Schema</legend>
                <pre>
                    {
                        xsds && Object.keys(xsds).map(
                        (filename, pos) => 
                            {
                                return (
                                    <React.Fragment key={pos}>
                                        {filename}{"\n"}{xsds[filename]}{"\n\n"}
                                    </React.Fragment>
                                )
                            }
                        )
                    }

                </pre>
            </fieldset>
        )
    }
 
};

class ViewDataDictionaryRdfs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idDataDictionary: null,
            isLoaded: false,
            isFailed: false, 
            RDFS: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idDataDictionary = getParam('idDataDictionary', this.props);

        if (StateChange.idDataDictionary){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.RDFS = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.RDFS = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getDataDictionaryVersion(dsd,StateChange.idDataDictionary,StateChange.idVersion, onLoad, onFail,'rdfs')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.RDFS}
                </pre>
            )
        }
        return <div/>
    }

};
        
export default function ViewDataDictionaryVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewDataDictionaryVersion {...props} navigation={navigation} location={location} params={params} />;
  }
